import React, { useState } from "react";
import { Box, Button, Typography, Grid } from "@mui/material";

const TimeSlotPicker = ({ selectedDate, setTimeSlot, handleNext, bookingMode,bookedSlots }) => {
    const [selectedSlot, setSelectedSlot] = useState(null);
    console.log(bookedSlots)
    const generateTimeSlots = () => {
        const day = selectedDate.day();
        let slots = [];

        if (bookingMode === "clinic") {
            if (day >= 1 && day <= 5 && day !== 3) {
                slots = ["5:00 PM", "5:15 PM", "5:30 PM", "5:45 PM", "6:00 PM", "6:15 PM", "6:30 PM", "6:45 PM"];
            } else if (day === 6) {
                slots = ["1:00 PM", "1:15 PM", "1:30 PM", "1:45 PM", "2:00 PM", "2:15 PM", "2:30 PM", "2:45 PM"];
            }
        } else if (bookingMode === "online") {
            if ([1, 2, 4, 5].includes(day)) {
                slots = ["8:00 PM", "8:15 PM", "8:30 PM", "8:45 PM", "9:00 PM", "9:15 PM"];
            }
        }
        return slots.filter((slot) => !bookedSlots?.includes(slot)); // Filter out booked slots
    };

    const slots = generateTimeSlots();
    return (
        <Box sx={{ padding: 3, textAlign: "center" }}>
            {slots.length > 0 ? (
                <>
                    <Typography variant="h5" sx={{ marginBottom: 2 }}>
                        Select a Time Slot
                    </Typography>
                    <Grid container spacing={2} justifyContent="center">
                        {slots.map((slot, index) => (
                            <Grid item key={index}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setSelectedSlot(slot);
                                        setTimeSlot(slot);
                                    }}
                                    sx={{
                                        minWidth: "100px",
                                        backgroundColor: selectedSlot === slot ? "#1976d2" : "white",
                                        color: selectedSlot === slot ? "white" : "black",
                                        borderColor: "#1976d2",
                                        "&:hover": {
                                            backgroundColor: "#e3f2fd",
                                            color: "#1976d2",
                                        },
                                    }}
                                >
                                    {slot}
                                </Button>
                            </Grid>
                        ))}
                    </Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        sx={{ marginTop: 3 }}
                        disabled={!selectedSlot}
                    >
                        Next: Fill Your Details
                    </Button>
                </>
            ) : (
                <Typography variant="h6" color="error">
                    No slots available for the selected date.
                </Typography>
            )}
        </Box>
    );
};

export default TimeSlotPicker;
